module.exports = __webpack_public_path__ + "img/multiplier_8_zh.87055e56.png";